module.exports = __webpack_public_path__ + "static/media/why-swimmy-mobile.d2536ac1.png";